import React from "react";
import { Container } from "react-bootstrap";
import { BASE_URL } from "../../constants";
const Packages = () => {
  return (
    <Container>
      <div className="packages-container">
        <h1 className="inteplanheading">Products</h1>

        {/* First Row */}
        <div className="row">
          <div className="package-item">
            <div className="dual-images">
              <img
                src={`${BASE_URL}products/hydrogen.png`}
                alt="Hydrogen"
                className="package-image"
              />
              <img
                src={`${BASE_URL}products/ammonia.png`}
                alt="Ammonia"
                className="package-image"
              />
            </div>
            <h2 className="package-heading">Hydrogen/ Ammonia</h2>
            <p className="package-text">
              Assess production, storage, and market potential for hydrogen and
              ammonia projects.
            </p>
          </div>

          <div className="package-item">
              <img
                src={`${BASE_URL}products/biofuel.png`}
                alt="Hydrogen"
                className="package-image"
              />
            <h2 className="package-heading">Bio-Intelligence</h2>
            <p className="package-text">
              Analyze and assess the economics of biofuel production for your projects..
            </p>
          </div>

          <div className="package-item">
              <img
                src={`${BASE_URL}products/ccus.png`}
                alt="Ammonia"
                className="package-image"
              />
            <h2 className="package-heading">CCUS</h2>
            <p className="package-text">
              Analyze the impact of Carbon capture, utilization and storage (CCUS) on your projects.
            </p>
          </div>
        </div>

        {/* Second Row */}          
        <div className="row">
          <div className="package-item1">
            <img
              src={`${BASE_URL}products/power.png`}
              alt="Power"
              className="package-image"
            />
            <h2 className="package-heading">Energy Planning</h2>
            <p className="package-text">
              Optimize power generation, distribution, and investment strategies
              with AI-driven insights.
            </p>
          </div>

          <div className="package-item1">
            <img
              src={`${BASE_URL}products/assets_value.png`}
              alt="Biofuel"
              className="package-image"
            />
            <h2 className="package-heading">
              TEA
            </h2>
            <p className="package-text">
              Accurately assess asset value and mitigate financial and
              operational risks in the energy sector.{" "}
            </p>
          </div>
        </div>
      </div>
      {/* Buttons Section */}
      {/* <Row className="justify-content-center mt-4 mb-4">
        <Col xs={12} md={6} className="d-flex justify-content-center gap-3">
          <div className="slider__btn">
            <Link
              to="/contact"
              className="z-btn"
              onClick={(e) => {
                e.preventDefault();
                const linkElement = document.getElementById("GetInTouchBtn");
                if (linkElement) {
                  linkElement.click();
                }
              }}
            >
              Request for Demo
            </Link>
          </div>
          <div>
            <Link to="/features">
              <Button className="custom-buttonmore">Learn More</Button>
            </Link>
          </div>
        </Col>
      </Row> */}
    </Container>
  );
};

export default Packages;
